import SearchBar from 'components/SearchBar'
import Select from 'components/Select'
import { useNavigate } from 'react-router-dom'

import { ACCOUNT_STAFF_OPTIONS } from 'resources/ACCOUNT_STAFF_OPTIONS'

type TProps = {
  query: string
  setQuery: React.Dispatch<React.SetStateAction<string>>
  handleChangeSelect: (val: string) => void
}

const AccountsFilters = ({ query, setQuery, handleChangeSelect }: TProps) => {
  const navigate = useNavigate()

  const onClickNew = () => {
    navigate('/accounts/add')
  }

  return (
    <div className="items-filters">
      <Select
        handleChange={handleChangeSelect}
        options={ACCOUNT_STAFF_OPTIONS}
        label="All Staff"
        nameClass="-shorter"
      />
      <SearchBar searchQuery={query} handleSearch={setQuery} />
      <button className="btn new-item" type="button" onClick={onClickNew}>
        <span className="new-item -cross"></span>
        <span className="new-item -cross"></span>
      </button>
    </div>
  )
}

export default AccountsFilters
